const getEncryptedUserUid = (user_uid) => {
  let a = user_uid.split('');
  let b = a.reverse();
  let c = b.join('');
  return c;
};

export default getEncryptedUserUid;
